import { BaseParser, IValidateParams } from './BaseParser';
import { ParseResult, IParseResult } from '../FormatterTypes';
import { formatterStrParamDef, setParamValue } from '../Utils/ParamUtils';
import { TEDFormatPersNr } from '../FormatterClasses/TEDFormatPersNr';
import { TEDFormatOrgNr } from '../FormatterClasses/TEDFormatOrgNr';

const numbers = '0123456789';
class TEDParseOrgNrPersNr extends BaseParser {
  public static getInstance(): TEDParseOrgNrPersNr {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDParseOrgNrPersNr;

  defaultParams(): string {
    return 'ValidSeps="-/ ,."';
  }

  getValidateParams(params: string): IValidateParams {
    const validSeps = formatterStrParamDef(
      'ValidSeps',
      params,
      this.defaultParams()
    );

    return { inputsList: numbers, separators: validSeps };
  }

  parse(text: string, params: string = ''): IParseResult {
    const defaultParams = this.defaultParams();
    const asPersNr = this.parseAsPersNr(text, params, defaultParams);
    if (
      asPersNr.result === ParseResult.ERROR ||
      asPersNr.result === ParseResult.ERROR_PATTERN
    ) {
      const asOrgNr = this.parseAsOrgNr(text, params, defaultParams);
      return { value: asOrgNr.value, result: asOrgNr.result };
    }

    return { value: asPersNr.value, result: asPersNr.result };
  }

  parseAsPersNr(
    text: string,
    params: string,
    defaultParams: string
  ): IParseResult {
    return new TEDFormatPersNr().parser.parse(
      text,
      setParamValue(
        'ValidPNSeps',
        formatterStrParamDef('ValidSeps', params, defaultParams),
        params
      )
    );
  }

  parseAsOrgNr(
    text: string,
    params: string,
    defaultParams: string
  ): IParseResult {
    return new TEDFormatOrgNr().parser.parse(
      text,
      setParamValue(
        'ValidONSeps',
        formatterStrParamDef('ValidSeps', params, defaultParams),
        params
      )
    );
  }
}

export { TEDParseOrgNrPersNr };
